<template>
  <div class="page page--no-padding page--form">
    <div class="beacon-form-container" :style="'transform: translateX(' + formPosition + '%)'">
      <div class="beacon-form__page">
        <h1 class="page-title" data-title="Nouvelle Balise">Nouvelle Balise</h1>
        <form class="form">
          <div class="form-group">
            <label for="beacon_id">Numéro de balise</label>
            <input name="beacon_id" id="beacon_id" min="0" v-model.number="form.beacon_id" type="number" placeholder="B1-Dinant">
          </div>
          <div class="form-group">
            <label for="mic_id">Numéro de micro</label>
            <input name="mic_id" id="mic_id" min="0" type="number" v-model.number="form.mic_id" placeholder="MDNF/2">
          </div>
          <div class="form-group">
            <label for="start_date">Date de pose</label>
            <input name="start_date" type="date" v-model="form.start_date">
          </div>
          <div class="form-group form-group--checkbox">
            <label class="label-radio is-reversed">
              <input name="alreadyRetreived" v-model="alreadyRetrived" id="alreadyRetreived" type="checkbox" @change="updateEndDate">
              <span class="label">J'ai déjà récupéré cette balise</span>
              <span class="fake-radio"></span>
            </label>
          </div>
          <div class="form-group" v-if="alreadyRetrived">
            <label for="start_date">Date de Récupération</label>
            <input name="start_date" type="date" v-model="form.end_date">
          </div>
        </form>
        <div class="beacon-form__button-nav">
          <button class="btn" @click="move('next')">Suivant</button>
        </div>
      </div>
      <div class="beacon-form__page">
        <h1 class="page-title page-title--form" data-title="Positions">
          <div class="beacon-form__button-prev">
            <svg viewBox="0 0 217.81 127.64"><path d="M95.66,122.16c7.32,7.31,19.18,7.31,26.5,0l90.63-90.63c7.06-7.58,6.64-19.44-0.94-26.5c-7.2-6.71-18.36-6.71-25.56,0 l-77.37,77.34L31.53,5.03c-7.58-7.06-19.44-6.64-26.5,0.94c-6.71,7.2-6.71,18.36,0,25.56L95.66,122.16z"/></svg>
            <button @click="move('prev')">Retour</button>
          </div>
          Positions
        </h1>
        <form class="form">
          <div class="form-group form-group--radio">
            <input type="radio" id="fixed" name="locationType" value="fixed" v-model="locationType">
            <label for="fixed">Point fixe</label>
            <input type="radio" id="coordinates" name="locationType" value="coordinates" v-model="locationType">
            <label for="coordinates">Coordonnées</label>
          </div>
          <div class="form-group" v-if="locationType === 'fixed'">
            <label for="fixed_position">Point fixe</label>
            <div class="select-wrapper">
              <svg viewBox="0 0 217.81 127.64"><path d="M95.66,122.16c7.32,7.31,19.18,7.31,26.5,0l90.63-90.63c7.06-7.58,6.64-19.44-0.94-26.5c-7.2-6.71-18.36-6.71-25.56,0 l-77.37,77.34L31.53,5.03c-7.58-7.06-19.44-6.64-26.5,0.94c-6.71,7.2-6.71,18.36,0,25.56L95.66,122.16z"/></svg>
              <select name="fixed_position" id="fixed_position" @change="setCoordsFromFixedLocation" v-model="form.fixed_position">
                <option value="0">Sélectionnez un point fixe</option>
                <option v-for="(location, index) in fixedLocations" :key="index" :value="location.code">{{location.code}} - {{ location.service }}</option>
              </select>
            </div>
          </div>
          <div class="form-group" v-if="locationType !== 'fixed'">
            <label for="latitude">Latitude</label>
            <input type="text" name="latitude" id="latitude" v-model="form.coordinates.x">
          </div>
          <div class="form-group" v-if="locationType !== 'fixed'">
            <label for="Longitude">Longitude</label>
            <input type="text" name="Longitude" id="Longitude" v-model="form.coordinates.y">
          </div>
          <div class="form-group" v-if="locationType !== 'fixed'">
            <button @click.prevent="locateMe" class="btn">Me localiser</button>
          </div>
        </form>
        <div class="beacon-form__button-nav">
          <button class="btn" @click="move('next')">Suivant</button>
        </div>
      </div>
      <div class="beacon-form__page">
        <h1 class="page-title page-title--form" data-title="Type de terrain">
          <div class="beacon-form__button-prev">
            <svg viewBox="0 0 217.81 127.64"><path d="M95.66,122.16c7.32,7.31,19.18,7.31,26.5,0l90.63-90.63c7.06-7.58,6.64-19.44-0.94-26.5c-7.2-6.71-18.36-6.71-25.56,0 l-77.37,77.34L31.53,5.03c-7.58-7.06-19.44-6.64-26.5,0.94c-6.71,7.2-6.71,18.36,0,25.56L95.66,122.16z"/></svg>
            <button @click="move('prev')">Retour</button>
          </div>
          Type de terrain
        </h1>
        <form class="form">
          <div class="form-group form-group--radio">
            <div class="select-container" v-for="(accommodation, index) in accommodations" :key="index">
              <input type="radio" :id="index" name="accommodation" :value="accommodation" v-model="form.accommodation">
              <label :for="index">
                <img  src="img/mare.svg">
                <span>{{ accommodation }}</span>
              </label>
            </div>
          </div>
        </form>
        <div class="beacon-form__button-nav">
          <button class="btn" @click="move('next')">Suivant</button>
        </div>
      </div>
      <div class="beacon-form__page">
        <h1 class="page-title page-title--form" data-title="Environnement">
          <div class="beacon-form__button-prev">
            <svg viewBox="0 0 217.81 127.64"><path d="M95.66,122.16c7.32,7.31,19.18,7.31,26.5,0l90.63-90.63c7.06-7.58,6.64-19.44-0.94-26.5c-7.2-6.71-18.36-6.71-25.56,0 l-77.37,77.34L31.53,5.03c-7.58-7.06-19.44-6.64-26.5,0.94c-6.71,7.2-6.71,18.36,0,25.56L95.66,122.16z"/></svg>
            <button @click="move('prev')">Retour</button>
          </div>
          Environnement
        </h1>
        <form class="form">
          <div class="form-group form-group--slider">
            <label class="range-label range-label--temperature" for="temperature">
              <span>Froid</span>
              <span>{{ temperatures[form.weather.temperature.day] }} °C</span>
              <span>Chaud</span>
            </label>
            <input name="temperature" id="temperature" v-model="form.weather.temperature.day" type="range" min="0" max="4" step="1">
          </div>
          <div class="form-group form-group--slider">
            <label class="range-label range-label--wind" for="temperature">
              <span>Calme</span>
              <!-- <span>{{ form.weather.wind }}</span> -->
              <span>Venteux</span>
            </label>
            <input name="temperature" id="temperature" v-model="form.weather.wind" type="range" min="0" max="5" step="1">
          </div>
          <div class="form-group form-group--slider">
            <label class="range-label range-label--dryness" for="temperature">
              <span>Sec</span>
              <!-- <span>{{ form.weather.dryness }}</span> -->
              <span>Humide</span>
            </label>
            <input name="temperature" id="temperature" v-model="form.weather.dryness" type="range" min="0" max="5" step="1">
          </div>
        </form>
        <div class="beacon-form__button-nav">
          <button class="btn" @click="move('next')">Suivant</button>
        </div>
      </div>
      <div class="beacon-form__page">
        <h1 class="page-title page-title--form" data-title="Finaliser">
          <div class="beacon-form__button-prev">
            <svg viewBox="0 0 217.81 127.64"><path d="M95.66,122.16c7.32,7.31,19.18,7.31,26.5,0l90.63-90.63c7.06-7.58,6.64-19.44-0.94-26.5c-7.2-6.71-18.36-6.71-25.56,0 l-77.37,77.34L31.53,5.03c-7.58-7.06-19.44-6.64-26.5,0.94c-6.71,7.2-6.71,18.36,0,25.56L95.66,122.16z"/></svg>
            <button @click="move('prev')">Retour</button>
          </div>
          Finaliser
        </h1>
        <form class="form">
          <div class="form-group">
            <label for="comment">Commentaire</label>
            <textarea name="comment" id="comment" v-model="form.comment"></textarea>
          </div>
        </form>
        <div class="summary">
          <ul>
            <li>Numéro de balise: {{ form.beaconId }}</li>
            <li>Numéro de micro: {{ form.micId }}</li>
            <li>Date de placement: {{ form.start_date }}</li>
            <li v-if="form.end_date">Date de récupération: {{ form.end_date }}</li>
            <li v-if="form.fixed_position">Point fixe: {{ form.fixed_position }}</li>
            <li>Longitude: {{ form.coordinates.x }}</li>
            <li>Latitude: {{ form.coordinates.y }}</li>
            <li>Type de terrain: {{ form.accommodation }}</li>
            <li>Humidité: {{ form.weather.dryness }}</li>
            <li>Vent: {{ form.weather.wind }}</li>
            <li>Température: {{ temperatures[form.weather.temperature.day] }} °C</li>
            <li v-if="form.comment">Commentaire: {{ form.comment }}</li>
          </ul>
        </div>
        <div class="beacon-form__button-nav">
          <button class="btn" @click="addBeacon">Terminer</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formPosition: 0,
      alreadyRetrived: false,
      locationType: 'fixed',
      fixedLocations: [],
      accommodations: [],
      temperatures: [
        '-10-0',
        '0-10',
        '10-20',
        '20-30',
        '40+'
      ],
      form: {
        beacon_id: '',
        mic_id: '',
        start_date: new Date().toISOString().slice(0, 10),
        end_date: false,
        fixed_position: 0,
        coordinates: {
          x: '',
          y: ''
        },
        accommodation: '',
        weather: {
          dryness: 0,
          wind: 0,
          temperature: {
            day: 0,
            night: 0
          }
        },
        comment: ''
      }
    }
  },
  created () {
    this.fixedLocations = require('@/assets/fixedLocations.json')
    this.accommodations = require('@/assets/accommodations.json')
  },
  methods: {
    async addBeacon () {
      await this.$store.dispatch('addBeacon', this.form)
      this.$router.push({ path: '/' })
    },
    updateEndDate (e) {
      if (e.target.checked) {
        this.form.end_date = new Date().toISOString().slice(0, 10)
      } else {
        this.form.end_date = false
      }
    },
    setCoordsFromFixedLocation (e) {
      const location = this.fixedLocations.filter(location => location.code === this.form.fixed_position)
      this.form.coordinates.x = location[0].x
      this.form.coordinates.y = location[0].y
    },
    locateMe () {
      navigator.geolocation.getCurrentPosition((pos) => {
        const crd = pos.coords
        this.form.coordinates.y = crd.latitude
        this.form.coordinates.x = crd.longitude
      }, (err) => {
        console.warn(`ERREUR (${err.code}): ${err.message}`)
      }, { enableHighAccuracy: true })
    },
    move (direction) {
      if (direction === 'next') {
        this.formPosition -= 100 / 5
      } else {
        this.formPosition += 100 / 5
      }
    }
  }
}
</script>
